
<template>
  <!--禁用小区-->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      apiOrigin="PHP"
      :dataSource="dataSource"
      rowKey="community_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'disabCommunity',
  data () {
    return {
      searchList: [
        { props: ['keywords'], placeholder: '小区名', options: [], inputType: 'input' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:disabCommunity:add'] }
      ],
      rowOptList: [
        { text: '删除', handle: record => this.$refs.table.showDeleteConfirm(record), permi: ['community:disabCommunity:remove'] }
      ],
      columns: [
        { title: '所在城市', dataIndex: 'area', align: 'left', width: '' },
        { title: '小区', dataIndex: 'community_name', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: undefined
      },
      listApi: {
        url: '/screen_show/blacklist',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addDisab',
        addTitle: '新增禁用小区'
      },
      deleteParam: {
        url: '/screen_show/blacklist',
        param: {pk_key: 'community_id', pk_val: ''},
        title: '小区',
        key: 'community_name'
      }
    };
  },
  created () {
  },
  methods: {
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
